import { useEffect, useRef, useState } from "react";
import { MyButton } from "../core/MyButton";
import "@/css/components/common/Navbar.css";
import { motion } from "framer-motion";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { t } from "i18next";
import { toggleTheme } from "@/utils/theme";

export const Navbar = () => {
    const [currentTheme, setCurrentTheme] = useState(localStorage.getItem("theme") || "light");

    const handleToggleTheme = () => {
        toggleTheme(setCurrentTheme);
    };

    return (
        <nav style={{
            top: 0,
            left: 0,
            right: 0,
            display: "flex",
            justifyContent: "space-between",
            backgroundColor: 'var(--color-bg-secondary)',
            color: 'var(--color-text)',
        }}>
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    gap: '5px',
                    alignItems: 'center',
                }}
            >
                <a href="/">
                    <img
                        style={{
                            borderRadius: "100px",
                            objectFit: "cover"
                        }}
                        src="../assets/pictures/my-profile1.jpg" alt="" />
                </a>

                <div>
                    <p>Yasin YILDIZ</p>
                    <p>{t("my-job")}</p>
                </div>
            </div>
            <div className="nav-right"
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                }}
            >
                <MyButton label={t("cv-download")} onClick={() => window.open("/assets/pdf/example-cv.pdf", "_blank")} />
                <TranslateToggle />
                <button
                    style={{
                        width: '40px',
                        height: '40px',
                        backgroundColor: '#3f51b5',
                        color: 'white',
                        border: 'none',
                        borderRadius: '5px'
                    }}
                    onClick={handleToggleTheme}>
                    {currentTheme === "dark" ? "🌙" : "☀️"}
                </button>
            </div>


        </nav >
    );
};

export default Navbar;

const TranslateToggle: React.FC = () => {
    const { i18n } = useTranslation();
    const selected = i18n.language.startsWith("tr") ? "TR" : "EN";

    const changeLanguage = (lng: "tr" | "en") => {
        i18n.changeLanguage(lng);
    };

    const handleToggle = () => {
        if (selected === "TR") {
            changeLanguage("en");
        } else {
            changeLanguage("tr");
        }
    };

    return (
        <div
            onClick={handleToggle}
            style={{
                position: "relative",
                width: 80,
                height: 40,
                backgroundColor: "#dededeff",
                borderRadius: 5,
                display: "flex",
                cursor: "pointer",
                userSelect: "none",
                fontWeight: 600,
                color: "#444",
            }}
        >
            <motion.div
                layout
                initial={false}
                animate={{ x: selected === "TR" ? 0 : 40 }}
                transition={{ type: "spring", stiffness: 500, damping: 30 }}
                style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: 40,
                    height: 40,
                    borderRadius: 5,
                    backgroundColor: "#007bff",
                    zIndex: 0,
                }}
            />

            <button
                style={{
                    flex: 1,
                    border: "none",
                    background: "transparent",
                    zIndex: 1,
                    color: selected === "TR" ? "white" : "#444",
                    borderRadius: 5,
                    outline: "none",
                    cursor: "pointer",
                }}
            >
                {t("lang-tr")}
            </button>
            <button
                style={{
                    flex: 1,
                    border: "none",
                    background: "transparent",
                    zIndex: 1,
                    color: selected === "EN" ? "white" : "#444",
                    borderRadius: 5,
                    outline: "none",
                    cursor: "pointer",
                }}
            >
                {t("lang-en")}
            </button>
        </div>
    );
};

